import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api, getPersona, setPersonaHeader } from "@/lib/api";
import { SourceDialog } from "@/components/meridian/SourceDialog";

const Ctx = createContext(null);
export const useApp = () => useContext(Ctx);

export function AppProvider({ children }) {
  const [tasks, setTasks] = useState([]);
  const [source, setSource] = useState(null);
  const [personas, setPersonas] = useState([]);
  const [personaId, setPersonaId] = useState(getPersona());
  const setPersona = useCallback((p) => { setPersonaHeader(p); setPersonaId(p); }, []);
  const refreshPersonas = useCallback(async () => {
    const { data } = await api.get("/personas");
    setPersonas(data.personas);
    if (!data.personas.some((p) => p.id === getPersona())) setPersona("harry");
  }, [setPersona]);
  useEffect(() => { refreshPersonas(); }, [refreshPersonas]);
  const persona = personas.find((p) => p.id === personaId);
  const personaLabel = persona ? `${persona.name} (${persona.role})` : "";
  const refreshTasks = useCallback(async () => {
    const { data } = await api.get("/tasks");
    setTasks(data);
  }, []);
  useEffect(() => { refreshTasks(); }, [refreshTasks]);
  return (
    <Ctx.Provider value={{ tasks, refreshTasks, openSource: setSource, personas, persona, personaId, setPersona, personaLabel, refreshPersonas }}>
      {children}
      <SourceDialog source={source} onChange={setSource} onClose={() => setSource(null)} />
    </Ctx.Provider>
  );
}
